import { NgModule } from '@angular/core';
import { AppRoutingModule } from 'app/app.routing';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoadingModule } from 'ngx-loading';
import { P500View } from 'app/views/pages/500.component';
import { P404View } from 'app/views/pages/404.component';
import { P403View } from 'app/views/pages/403.component';
import { P401View } from 'app/views/pages/401.component';
import { LoginView } from 'app/views/pages/login.component';
import { AuthService } from "app/services/auth/auth.service";
import { RecaptchaModule } from 'ng-recaptcha';
import { RecaptchaFormsModule } from 'ng-recaptcha/forms';
import { RedirectService } from 'app/services/page/redirect.service';
import { RedirectView } from 'app/views/pages/redirect.component';

@NgModule({
    imports: [AppRoutingModule, FormsModule, LoadingModule, RecaptchaModule.forRoot(), RecaptchaFormsModule],
    declarations: [P500View, P404View, P403View, P401View, LoginView, RedirectView],
    providers: [AuthService, RedirectService],
    exports: [P500View, P404View, P403View, P401View, LoginView]
})
export class PagesViewModule { }



// WEBPACK FOOTER //
// E:/02_workspace/TenneT/git/tennet_suggestion_box/client/src/app/views/pages/pages.module.ts